<div class="device-users">
  <div class="modal-main px-2 pt-4">
    <div
      class="header d-flex flex-column justify-content-center px-3 pt-2 py-1"
    >
      <div class="d-flex justify-content-between">
        <div class="col-1">
          <img
            src="/assets/svg/ico-chevron-back-outline.svg"
            class="pointer-cursor"
            (click)="navigateBack()"
          />
        </div>

        <div class="col-10">
          <h1 class="modal-title text-center">
            {{ "USERS_ACCESS" | translate }}
          </h1>
        </div>

        <div class="col-1 text-right">
          <img
            src="/assets/svg/ico-hamburger-close.svg"
            class="cross-button pointer-cursor pt-1"
            (click)="closeDialog()"
          />
        </div>
      </div>
    </div>
    <div class="mb-5">
      <p class="text-center heading-one">{{ "USERS" | translate }}</p>
    </div>

    <div class="content pb-4 position-relative">
      <div class="row my-2 mx-2">
        <div class="mt-4 w-100">
          <ng-container *ngFor="let user of userList">
            <div class="row py-3 my-2 mx-2 item pointer-cursor">
              <div class="col-3 text-center">
                <app-profile-picture
                  [name]="user?.firstName + ' ' + user?.lastName"
                  [userData]="user"
                >
                </app-profile-picture>
              </div>
              <div class="col-8">
                <div class="col-12 heading">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ user?.firstName }} {{ user.lastName }}
                  </app-with-tooltip>
                </div>
                <div class="col-12 status mt-2">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ user?.userType | userTypeResponse | translate }}
                  </app-with-tooltip>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
